import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import ProfilePicker from '../picker/ProfilePicker'

const ProfilesFilter = ({ field, ...props }) => {
  field = field || 'profileIds'
  const label = 'Perfil'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <ProfilePicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default ProfilesFilter
